<template>
    <b-modal :id="id" :title="title" size="xl" ok-only ok-title="Tutup">
        <iframe
            v-if="type === 'pdf' && url"
            :src="url"
            class="preview-file"
            title="Preview PDF"
        />
        <b-img v-else-if="url" :src="url" fluid />
        <p v-else class="mb-0">File tidak tersedia.</p>
    </b-modal>
</template>

<script>
export default {
    name: "modal-kas-kecil-file-preview",
    props: {
        id: { type: String, required: true },
        title: { type: String, default: "" },
        url: { type: String, default: "" },
        type: { type: String, default: "image" },
    },
}
</script>

<style scoped>
.preview-file {
    border: 0;
    height: 75vh;
    width: 100%;
}
</style>
